<template lang="pug">
.question-edit
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/safety_confirmations") {{ $t('Safety Confirmation List')}}
    li.active(v-if="isEdit")
      span {{ $t('Safety Confirmation Edit') }}
    li.active(v-else)
      span {{ $t('Safety Confirmation New') }}

  //- タイトル
  h2(v-if="isEdit" style="text-align: center;") {{ $t('Safety Confirmation Edit') }}
  h2(v-else style="text-align: center;") {{ $t('Safety Confirmation New') }}

  form.form-horizontal
    template
      .row.margin-top
        label.col-sm-3.control-label 対象店舗
        .col-sm-9
          input(type='checkbox', v-model="safetyConfirmationAllCheck", v-on:click="safetyConfirmationAllChecked", style="margin-right: 5px;", id="service-question-user-type-all-check", :disabled="isClosed ? 'disabled' : false") 
          label(for="service-question-user-type-all-check") 全選択
      template(v-for="area in areas")
        .row.margin-top
          .col-sm-3
          .col-sm-9
            input(type='checkbox', :checked="safetyConfimationAreaIds.indexOf(area.id) >= 0", v-on:click="safetyConfirmationAreaChecked(area.id)", v-bind:value="area.id", style="margin-right: 5px;",
            :id="'safety_confirm_area_' + area.id", :disabled="isClosed ? 'disabled' : false") 
            label(:for="'safety_confirm_area_' + area.id") {{ area.attributes['name'] }}エリア
        .row
          .col-sm-3
          .col-sm-9
            .row
              .col-sm-4(v-for="(shop, index) in area.attributes.shops")
                input(type='checkbox', v-model="safetyConfimationShopIds", v-bind:value="shop.id", style="margin-right: 5px;",
                :id="'safety_confirm_shop_' + area.id + '_' + index", :disabled="isClosed ? 'disabled' : false") 
                label(:for="'safety_confirm_shop_' + area.id + '_' + index") {{ shop['name'] }}
      p.validation-msg(v-show="!validation.safetyConfimationShopIds") {{ $t('validations.check') }}
    
    .row.margin-top(v-if="!isClosed")
      .col-sm-12.text-center
        input(type='checkbox', v-model="isTraining", style="margin-right: 5px;", id="is-training-check", :disabled="isEdit ? 'disabled' : false") 
        label(for="is-training-check") 
          span 安否確認を
          strong 訓練
          span として公開する
      .col-sm-12.text-center(v-if="isEdit")
        a.btn.btn-lg.btn-danger(style="margin-right: 5px;", v-on:click="onClickUpdate()", v-bind:class="{disabled: !validation.safetyConfimationShopIds}")
          span {{ $t('Safety Confirmation Update') }}
      .col-sm-12.text-center(v-else)
        a.btn.btn-lg.btn-danger(style="margin-right: 5px;", v-on:click="onClickSave()", v-bind:class="{disabled: !validation.safetyConfimationShopIds}")
          span {{ $t('Safety Confirmation Save') }}
    .row.margin-top(v-if="isEdit && !isClosed")
      .col-sm-12.text-center
        a.btn.btn-default(v-on:click="onClickClose()")
          i.fa.fa-close
          span {{ $t('Safety Confirmation Close') }}
</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'service-question-edit',
  created () {
    if (!this.isSystemManagement) {
      this.$router.push({ path: '/' })
    }
    const loadData = async () => {
      await this.getAreas()
      if (this.$route.params.id > 0) {
        await this.getSafetyConfirmation()
      }
    }
    loadData()
  },
  data () {
    return {
      safetyConfirmationAllCheck: false,
      isTraining: false,
      safetyConfimationAreaIds: [],
      safetyConfimationShopIds: [],
      canValidate: true,
      savingFlag: false,
      isClosed: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.params.id > 0
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    validation: function () {
      var v = {
        safetyConfimationShopIds: this.safetyConfimationShopIds.length > 0
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    areas () {
      return this.$store.getters.areas
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getAreas () {
      await this.$store.dispatch('AREA_ALL_GET', {})
    },
    async getSafetyConfirmation () {
      this.$store.dispatch('GET_SAFETY_CONFIRMATION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        console.log(res)
        this.isTraining = res.safety_confirmation.is_training
        this.isClosed = !!res.safety_confirmation.closed_at
        this.safetyConfimationShopIds = res.shops.map((shop) => shop.shop_id)
      })
      .catch(err => console.log(err))
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.$store.dispatch('CREATE_SAFETY_CONFIRMATION', {
        data: {
          is_training: this.isTraining,
          shops: this.safetyConfimationShopIds
        }
      })
      .then(res => {
        this.$router.push({path: '/safety_confirmations'})
      })
      .catch(err => console.log(err))
    },
    onClickUpdate: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.$store.dispatch('UPDATE_SAFETY_CONFIRMATION', {
        id: this.$route.params.id,
        data: {
          is_training: this.isTraining,
          shops: this.safetyConfimationShopIds
        }
      })
      .then(res => {
        this.$router.push({path: '/safety_confirmations'})
      })
      .catch(err => console.log(err))
    },
    onClickClose: function () {
      if (this.savingFlag) return false

      if (window.confirm(this.$t('Confrim Closing Safety Confirmation'))) {
        this.savingFlag = true
        this.$store.dispatch('CLOSE_SAFETY_CONFIRMATION', {
          id: this.$route.params.id
        })
        .then(res => {
          this.$router.push({path: '/safety_confirmations'})
        })
        .catch(err => console.log(err))
      }
    },
    onClickCancel: function () {
      this.$router.push({path: '/safety_confirmations'})
    },
    safetyConfirmationAreaChecked: function (areaId) {
      if (this.safetyConfimationAreaIds.indexOf(areaId) < 0) {
        this.safetyConfimationAreaIds.push(areaId)
        this.areas.filter(area => area.id === areaId).map((area) => area.attributes.shops.map((shop) => this.safetyConfimationShopIds.push(shop.id)))
      } else {
        this.safetyConfimationAreaIds = this.safetyConfimationAreaIds.filter(area => area !== areaId)
        const shopIds = []
        this.areas.filter(area => area.id === areaId).map((area) => area.attributes.shops.map((shop) => shopIds.push(shop.id)))
        this.safetyConfimationShopIds = this.safetyConfimationShopIds.filter(shopId => shopIds.indexOf(shopId) < 0)
      }
    },
    safetyConfirmationAllChecked: function () {
      if (this.safetyConfirmationAllCheck) {
        this.areas.map((area) => {
          if (this.safetyConfimationAreaIds.indexOf(area.id) < 0) {
            this.safetyConfimationAreaIds.push(area.id)
          }
          area.attributes.shops.map((shop) => this.safetyConfimationShopIds.push(shop.id))
        })
      } else {
        this.safetyConfimationShopIds = []
        this.safetyConfimationAreaIds = []
      }
    }
  }
}
</script>
<style scoped>
strong {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// SafetyConfirmationEdit.vue?87cdfca2